module.exports = __webpack_public_path__ + "928d052704dbebc2c9c4523ad36d3024.svg";